var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1238_3709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.99056 7.51286C0.99056 6.98682 0.938477 6.46078 1.00098 5.95036C1.11035 5.07536 1.88639 4.42953 2.7666 4.40348C3.09993 4.39307 3.42806 4.40348 3.7666 4.38786C3.33951 4.26807 2.98535 4.04411 2.75097 3.65869C2.5166 3.27848 2.4541 2.86182 2.57389 2.42431C2.77181 1.70556 3.44889 1.2316 4.18847 1.28369C4.92805 1.33577 5.52701 1.9139 5.62597 2.66911C5.72493 3.43994 5.25097 4.09098 4.38118 4.39828C4.66764 4.39828 4.9593 4.39828 5.24576 4.39828C6.39159 4.40348 7.18847 5.20557 7.19367 6.3514C7.19367 6.73161 7.19367 7.11703 7.19367 7.50766C5.11555 7.51286 3.05306 7.51286 0.99056 7.51286Z",
    fill: "#AAABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0479 19.3668C16.9645 19.3668 14.902 19.3668 12.8239 19.3668C12.8187 19.3096 12.8135 19.2575 12.8135 19.2002C12.8239 18.7314 12.7926 18.2627 12.8551 17.7991C12.9697 16.9345 13.7406 16.2835 14.6104 16.2575C14.9489 16.247 15.2874 16.2575 15.626 16.2418C15.1989 16.122 14.8499 15.9033 14.6156 15.5231C14.3812 15.1481 14.3135 14.7366 14.4229 14.3095C14.5999 13.596 15.2666 13.1064 16.0166 13.1376C16.7562 13.1689 17.3604 13.7262 17.4801 14.4918C17.5999 15.2679 17.1364 15.9189 16.1989 16.2575C16.5322 16.2575 16.8239 16.2575 17.1104 16.2575C18.2458 16.2627 19.0479 17.0647 19.0531 18.195C19.0479 18.5752 19.0479 18.9606 19.0479 19.3668Z",
    fill: "#AAABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0467 9.52082C10.269 9.31704 10.5283 9.08548 10.7692 8.84466C11.5287 8.06662 12.5661 7.98325 13.2978 8.65941C14.0573 9.35409 14.1407 10.5304 13.4275 11.3085C12.5198 12.2995 11.5842 13.2443 10.6487 14.2076C10.4542 14.4114 10.2412 14.6059 10.0189 14.8097C10.0004 14.8004 9.96332 14.7911 9.93554 14.7633C8.83331 13.6241 7.73108 12.4941 6.64738 11.3455C6.00827 10.6694 5.96196 9.68754 6.48065 8.95581C7.11976 8.05735 8.33314 7.9462 9.13897 8.70572C9.45389 8.98359 9.75029 9.25221 10.0467 9.52082Z",
    fill: "#AAABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1238_3709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0217285 0.310059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedProfiles);
export default __webpack_public_path__ + "static/media/matched_profiles.641deda9a3c6530874d9eace89234c4e.svg";
export { ForwardRef as ReactComponent };